import axios, { type AxiosInstance } from 'axios';

const baseURL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000';
console.log('[Axios] Initializing with baseURL:', baseURL);

const axiosInstance: AxiosInstance = axios.create({
  // Use env when provided; default to direct dev API at localhost:3000
  baseURL: baseURL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // CRITICAL: Always send credentials (cookies) with requests
  maxRedirects: 5, // Allow following redirects (default behavior)
});

// Add request interceptor to log cookies being sent
axiosInstance.interceptors.request.use(
  (config) => {
    if (config.url?.includes('profile')) {
      console.log('[Axios Request] 📤 Sending request to:', config.url, {
        fullUrl: config.baseURL + config.url,
        withCredentials: config.withCredentials,
        cookies: document.cookie,
        hasCookies: document.cookie.length > 0,
      });
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for debugging and proper error handling
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.error('[Axios] Request failed:', {
      status: error?.response?.status,
      statusText: error?.response?.statusText,
      url: error?.config?.url,
      message: error?.message,
    });
    return Promise.reject(error);
  }
);

export default axiosInstance;